<template>
  <div class="table-list" v-loading="loading">
    <div class="table-content">
      <!-- 表格数据 -->
      <el-table
        :data="listData"
        header-cell-class-name="dark"
        :height="tableHeight"
        stripe
        border
      >
        <table-column label="序号" width="60" type="index" />
        <table-column prop="createTime" label="建档时间" />
        <table-column prop="passagewayName" label="通道全称" />
        <table-column prop="id" label="通道号" />
        <table-column prop="passagewayAbbreviationName" label="通道简称" />
        <table-column prop="productName" label="产品名称"> </table-column>
        <table-column prop="communicationSt" label="通讯方式">
          <span slot-scope="scope">{{
            scope.row.communicationSt | filterCommunicationSt
          }}</span>
        </table-column>
        <table-column prop="channelType" label="通道类型">
          <span slot-scope="scope">{{
            scope.row.channelType | filterChannelType
          }}</span>
        </table-column>
        <table-column prop="sourceChannelType" label="通道来源">
          <span slot-scope="scope">{{
            scope.row.sourceChannelType | filterSourceChannelType
          }}</span>
        </table-column>

        <table-column prop="status" label="通道状态">
          <span slot-scope="scope">{{ scope.row.status | filStatus }}</span>
        </table-column>

        <el-table-column width="80">
          <div slot="header" class="fixed-right-column">操作</div>
          <div class="actions-bar" slot-scope="scope">
            <router-link
              class="active"
              :to="`/home/paymentChannel/details/${scope.row.id}`"
              >查看</router-link
            >
            <router-link
              class="active"
              :to="`/home/paymentChannel/editor/${scope.row.id}`"
              >修改</router-link
            >
          </div>
        </el-table-column>
        <!-- 表格数据 end -->
      </el-table>
    </div>
  </div>
</template>

<script>
import mixin from '@/mixins/dataListHeight.js'
export default {
  mixins: [mixin],
  props: {
    listData: {
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  filters: {
    filBillingMode(value) {
      return {
        1: '万分比',
        2: '笔算'
      }[value]
    },
    filSettlest(value) {
      return {
        0: 'T0',
        1: 'T1'
      }[value]
    },
    filStatus(value) {
      return {
        1: '正常',
        2: '停用'
      }[value]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/Common/tableList.scss';

.actions-bar a {
  margin: 0 5px;
}
</style>
